export enum UserTypeEnum {
  OWNER = 'owner',
  STAFF = 'staff',
  PRODUCTION = 'production',
  WAREHOUSE_MANAGER = 'warehouse_manager',
}
